import { render, staticRenderFns } from "./BContentCard.vue?vue&type=template&id=09cbe1a5"
import script from "./BContentCard.vue?vue&type=script&lang=js"
export * from "./BContentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports